import React from 'react';
import "./index.css";
import {Link} from 'gatsby';

export class Footer extends React.Component{

    constructor(props){
        super(props);
    }

    goUp(ev){
        ev.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    render(){
        return (
            <div className='footer'>
                <div> © Copyright 2020 by Magyk Software </div>
                <div>
                    <Link to="/" className='link'>
                        Home
                    </Link>
                    <Link to="/careers" className='link'>
                        Careers
                    </Link>
                    <Link to="/" className='link' onClick={this.goUp}>
                        <span className="material-icons">keyboard_arrow_up</span>
                    </Link>
                </div>
            </div>
        )
    }
}